<div class="px-6 py-4 border-b border-gray-100 bg-white flex flex-row justify-between items-center gap-4">
  <div class="flex items-center gap-3 min-w-0">
    <span class="h-10 w-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center flex-shrink-0"><mat-icon>upload_file</mat-icon></span>
    <div class="min-w-0">
      <h1 class="text-xl font-bold text-gray-900 leading-tight">Update container lines</h1>
      <p class="text-xs text-gray-500 truncate">{{ data.fileName }} - check the changes, nothing is saved yet</p>
    </div>
  </div>
  <button type="button" (click)="dialogRef.close(false)" class="h-9 w-9 rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-800 flex items-center justify-center flex-shrink-0" aria-label="Close">
    <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mat-typography !px-6 !py-5 !max-h-[64vh]">
  <!-- Summary -->
  <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
    <div class="rounded-xl bg-sky-50 border border-sky-100 px-4 py-3">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-sky-700/70">Shipments</div>
      <div class="text-2xl font-bold text-sky-700">{{ data.result.shipments }}</div>
    </div>
    <div class="rounded-xl bg-violet-50 border border-violet-100 px-4 py-3">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-violet-700/70">Containers</div>
      <div class="text-2xl font-bold text-violet-700">{{ data.result.containers }}</div>
    </div>
    <div class="rounded-xl bg-amber-50 border border-amber-100 px-4 py-3">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-amber-700/70">Lines</div>
      <div class="text-2xl font-bold text-amber-700">{{ data.result.lines }}</div>
    </div>
    <div class="rounded-xl border px-4 py-3" [ngClass]="data.result.errors.length ? 'bg-red-50 border-red-100' : 'bg-gray-50 border-gray-100'">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-500">Errors</div>
      <div class="text-2xl font-bold" [ngClass]="data.result.errors.length ? 'text-red-600' : 'text-gray-300'">{{ data.result.errors.length }}</div>
    </div>
  </div>

  @if (data.result.errors.length) {
  <div class="mb-4 rounded-xl bg-red-50 border border-red-200 px-4 py-3">
    <div class="text-sm font-semibold text-red-800 mb-1.5">Fix these in the file and import again - nothing is saved while there are errors</div>
    @for (e of data.result.errors; track $index) {
    <div class="flex items-start gap-1.5 text-xs text-red-700 mt-1"><mat-icon class="!text-[14px] !h-3.5 !w-3.5 flex-shrink-0 mt-px">close</mat-icon>{{ e }}</div>
    }
  </div>
  }
  @if (data.result.warnings.length) {
  <div class="mb-4 rounded-xl bg-amber-50 border border-amber-200 px-4 py-3">
    @for (w of data.result.warnings; track $index) {
    <div class="flex items-start gap-1.5 text-xs text-amber-900 mt-0.5"><mat-icon class="!text-[14px] !h-3.5 !w-3.5 flex-shrink-0 mt-px">warning_amber</mat-icon>{{ w }}</div>
    }
  </div>
  }

  @if (!data.result.changes.length && !data.result.errors.length) {
  <div class="rounded-xl bg-gray-50 border border-gray-100 px-4 py-8 text-center text-sm text-gray-500">
    <mat-icon class="!text-[28px] !h-7 !w-7 text-gray-300">done_all</mat-icon>
    <div class="mt-1 font-semibold text-gray-700">Nothing to change</div>
    <div class="text-xs">The file matches what's saved.</div>
  </div>
  }

  <!-- Changes, field by field -->
  @for (lv of levels; track lv.key) {
  @if (changesAt(lv.key).length) {
  <div class="mb-4">
    <div class="flex items-center gap-2 mb-2">
      <mat-icon class="!text-[16px] !h-4 !w-4 text-gray-400">{{ lv.icon }}</mat-icon>
      <span class="text-[11px] font-bold uppercase tracking-wider text-gray-500">{{ lv.label }}</span>
      <span class="text-[11px] text-gray-400">{{ changesAt(lv.key).length }} change{{ changesAt(lv.key).length === 1 ? '' : 's' }}</span>
    </div>
    <div class="rounded-xl border border-gray-200 overflow-hidden divide-y divide-gray-100">
      @for (c of changesAt(lv.key); track $index) {
      <div class="grid grid-cols-[minmax(0,1.6fr)_110px_minmax(0,1fr)_16px_minmax(0,1fr)] items-center gap-3 px-3 py-2 text-xs">
        <span class="font-semibold text-gray-900 truncate" [title]="c.ref">{{ c.ref }}</span>
        <span class="text-gray-500">{{ c.field }}</span>
        <span class="text-gray-400 line-through truncate" [title]="c.from">{{ c.from }}</span>
        <mat-icon class="!text-[14px] !h-3.5 !w-3.5 text-amber-600">arrow_forward</mat-icon>
        <span class="font-semibold text-gray-900 truncate" [title]="c.to">{{ c.to }}</span>
      </div>
      }
    </div>
  </div>
  }
  }
</mat-dialog-content>

<div class="px-6 py-4 border-t border-gray-100 bg-white flex flex-row items-center justify-between gap-3 flex-wrap">
  <span class="text-xs text-gray-400">Received containers are never changed.</span>
  <div class="flex items-center gap-3">
    <button type="button" (click)="dialogRef.close(false)" class="px-5 py-2.5 rounded-xl border border-gray-200 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50">Cancel</button>
    <button type="button" [disabled]="applying || data.result.errors.length > 0 || !data.result.changes.length" (click)="apply()"
      class="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 font-bold text-sm shadow-md shadow-amber-200 hover:from-amber-300 hover:to-amber-400 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none">
      @if (applying) { <mat-spinner diameter="16"></mat-spinner> } @else { <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">check</mat-icon> }
      Save {{ data.result.changes.length }} change{{ data.result.changes.length === 1 ? '' : 's' }}
    </button>
  </div>
</div>
